module.exports = __webpack_public_path__ + "82267d7073c1ff9ac60dcc3a0bb9552a.MP3";